import { useEffect } from "react";
import { useSelector } from "react-redux";
import { applyBusinessTheme, clearBusinessTheme } from "../../theme/applyBusinessTheme";

/**
 * Aplica el tema del cliente activo (variables CSS + data-business-group).
 * Usar en cada página interna que tenga BarraMenu.
 */
const useDigitalTheme = () => {
  const { idbusiness_group } = useSelector((state: any) => state.emp);

  useEffect(() => {
    applyBusinessTheme(idbusiness_group);
    return () => clearBusinessTheme();
  }, [idbusiness_group]);
};

export default useDigitalTheme;
